import { render } from "./LiveBoard.vue?vue&type=template&id=0d564ab4"
import script from "./LiveBoard.vue?vue&type=script&lang=js"
export * from "./LiveBoard.vue?vue&type=script&lang=js"

import "./LiveBoard.vue?vue&type=style&index=0&id=0d564ab4&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__